import React, { useEffect, useState } from 'react'
import style from '../../surveys.module.scss'
import TextArea from 'src/Components/Form/TextArea'
import Input from 'src/Components/Form/Input'
import Select from 'src/Components/Form/Select'
import { ISurveySettings } from 'src/utils/Interfaces/survey.interface'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'
import { Switch } from 'src/Components/Form/Switch'

interface Props {
  data: ISurveySettings
  update: (i: ISurveySettings) => void
}

const SettingsBlock = ({ data, update }: Props) => {
  const [settings, setSettings] = useState(data)
  const [updateBtn, setUpdateBtn] = useState(false)

  useEffect(() => {
    setSettings(data)
  }, [data])

  useEffect(() => {
    setUpdateBtn(JSON.stringify(data) !== JSON.stringify(settings))
  }, [settings, data])

  const handleSettingsUpdate = () => {
    update(settings)
  }

  const handleAddRule = () => {
    if (!settings.target) setSettings({ ...settings, target: [] })
    setSettings((prev) => ({ ...prev, target: [...(prev.target || []), { type: 'url', rule: 'contains', value: [] }] }))
  }

  return (
    <div className={style.settings_block}>
      <TextArea
        label="Finish text"
        name="finish_text"
        value={settings.finishText || ''}
        onChange={(e) => setSettings({ ...settings, finishText: e.target.value })}
      />
      <Input
        value={settings.minimalText ?? ''}
        name="minimal_text"
        label="Minimal text"
        onChange={(e) => setSettings({ ...settings, minimalText: e.target.value })}
      />
      <div>
        Mobile full -{' '}
        <Switch
          checked={settings.mobileFull ?? false}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSettings({ ...settings, mobileFull: e.target.checked })
          }
        />
      </div>
      <div>
        Desktop full -{' '}
        <Switch
          checked={settings.desktopFull ?? false}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSettings({ ...settings, desktopFull: e.target.checked })
          }
        />
      </div>
      <h4>Target</h4>
      <ul className={style.target_list}>
        {settings.target?.map((i, index) => (
          <li key={index}>
            <Select
              list={['url', 'path']}
              value={i.type}
              label="Type"
              onChange={(e) =>
                setSettings({
                  ...settings,
                  target: settings.target?.map((item, ind) => (ind === index ? { ...item, type: e } : item))
                })
              }
            />
            <Select
              list={['contains', 'equals', 'regex', 'not_contains', 'not_equals']}
              value={i.rule}
              label="Rule"
              onChange={(e) =>
                setSettings({
                  ...settings,
                  target: settings.target?.map((item, ind) => (ind === index ? { ...item, rule: e } : item))
                })
              }
            />
            <Input
              value={i.value.join(',')}
              name="value"
              label="Value"
              onChange={(e) =>
                setSettings({
                  ...settings,
                  target: settings.target?.map((item, ind) =>
                    ind === index ? { ...item, value: e.target.value.split(',') } : item
                  )
                })
              }
            />
            <RemoveCircleOutlineOutlinedIcon
              onClick={() =>
                setSettings({
                  ...settings,
                  target: settings.target?.filter((_, ind) => ind !== index)
                })
              }
            />
          </li>
        ))}
      </ul>
      <p className={style.add_rule} onClick={handleAddRule}>
        + add rule
      </p>
      <Select
        list={['DESKTOP', 'MOBILE', 'ALL']}
        value={settings.devices ?? 'ALL'}
        label="Devices"
        onChange={(e) => setSettings({ ...settings, devices: e })}
      />
      <h4>Triggers</h4>
      <div className={style.block}>
        SPA -{' '}
        <Switch checked={settings.spa || false} onChange={(e) => setSettings({ ...settings, spa: e.target.checked })} />
      </div>
      <div className={style.block}>
        Events -{' '}
        <Input
          value={settings.events?.join(',')}
          name="events"
          label="Events"
          onChange={(e) => setSettings({ ...settings, events: e.target.value.split(',') })}
        />
      </div>
      <div className={style.block}>
        Duration -
        <Switch
          checked={settings.duration?.status || false}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSettings({ ...settings, duration: { value: 0, status: e.target.checked } })
          }
        />
        {settings.duration?.status && (
          <Input
            value={settings.duration?.value.toString() || '0'}
            name="duration"
            label="Time"
            type="number"
            min="0"
            max="1000"
            onChange={(e) => setSettings({ ...settings, duration: { status: true, value: +e.target.value } })}
          />
        )}
      </div>
      <div className={style.block}>
        Exit Intent -{' '}
        <Switch
          checked={settings.exitIntent?.status || false}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSettings({ ...settings, exitIntent: { value: 70, status: e.target.checked } })
          }
        />
        {settings.exitIntent?.status && (
          <Input
            value={settings.exitIntent?.value.toString() || '70'}
            name="exit_intent"
            label="Scroll speed"
            type="number"
            min="50"
            max="300"
            onChange={(e) => setSettings({ ...settings, exitIntent: { status: true, value: +e.target.value } })}
          />
        )}
      </div>
      {updateBtn && (
        <button onClick={handleSettingsUpdate} className="btn">
          Update
        </button>
      )}
    </div>
  )
}

export default SettingsBlock
